<template>
  <v-btn @click="signIn" color="grey lighten-4" large>
    <v-icon left>mdi-google</v-icon>Sign In
  </v-btn>
</template>

<script>
import Vue from "vue";
import GAuth from "vue-google-oauth2";

const gauthOption = {
  clientId: process.env.VUE_APP_AUTH_GOOGLE_CLIENTID,
  scope: "profile email",
  prompt: "select_account",
  access_type: "offline"
};

Vue.use(GAuth, gauthOption);

export default {
  methods: {
    signIn() {
      // let authCode = true;
      // this.$store.dispatch("user/login", authCode);
      // this.$router.push({ name: "Projects" });
      this.$gAuth
        .getAuthCode()
        .then(authCode => {
          console.log("made it to the getAuth");
          this.$store
            .dispatch("user/login", authCode)
            .then(() => {
              this.$router.push({
                name: "Projects"
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });
    },

    signInAlt() {
      this.$store.dispatch("user/setUser", {});
      this.$router.push({
        name: "Projects"
      });
      console.log("here");
    }
  }
};
</script>

<style lang="scss"></style>
